import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Dashboard from './Dashboard';

/**
 * Wraps the existing Dashboard component inside the Growth Hub layout.
 * The existing Dashboard manages its own internal view state, so we
 * simply embed it. A small top breadcrumb helps users get back to Hub.
 */
const TacticalsPage = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="tacticals-page">
      <div className="px-12 pt-6 pb-0">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-800 font-medium"
          data-testid="back-to-hub-from-tacticals"
        >
          <ArrowLeft className="w-3 h-3" /> Back to Growth Hub
        </button>
      </div>
      <Dashboard />
    </div>
  );
};

export default TacticalsPage;
